import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

const propTypes = {
  children: PropTypes.element.isRequired,
};

const BACKSPACE = 'Backspace';

// this wrapper takes a single child, injects an onKeyDown handler that does not
// cause a rerender and supplies the backspace arg to the wrapped component's
// onChange method
class BackspaceProvider extends PureComponent {
  constructor(props) {
    super(props);
    this.backspace = false;
  }

  keyDownHandler = (e) => {
    this.backspace = e.key === BACKSPACE;
  }

  changeHandler = (e) => {
    this.props.children.props.onChange(e, this.backspace);
  }
  render() {
    const { children } = this.props;
    return React.cloneElement(children, {
      onKeyDown: this.keyDownHandler,
      onChange: this.changeHandler,
    });
  }
}

BackspaceProvider.propTypes = propTypes;

export default BackspaceProvider;